angular
  .module('company')

  .factory('CertificationCrud', [
    'Crud',

    function(Crud) {
      'use strict';

      class CertificationCrud extends Crud {
        constructor(list) {
          super(
            'certification' + (list || ''),
            '@@apiUrl' + '/certifications' + (list || '') + '/:id',
            { id: '@id' },
            {
              query: {
                method: 'GET',
                isArray: true
              }
            }
          );
        }
      }

      return CertificationCrud;
    }
  ]);
